import { useTranslation } from 'react-i18next';
import { VideoPlayer } from 'src/components/common/video';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { PartialResourcePage } from 'src/components/resource/form/types';
import styles from './styles.module.css';

interface ResourceDetailsProps {
  resource: PartialResourcePage;
}

export const ResourceDetails = ({ resource }: ResourceDetailsProps) => {
  const { t } = useTranslation();

  const items = resource.items || [];

  return (
    <ContentWrapper>
      <TableWrapper>
        {items.map((item) => (
          <div key={item.id}>
            <div
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: item.description || '' }}
            />
            {item.video && (
              <VideoPlayer
                key={item.id}
                video={item.video}
                className={styles.videoWrapper}
              />
            )}
          </div>
        ))}
      </TableWrapper>
    </ContentWrapper>
  );
};
